import React, { Component } from 'react';
import MyAnimoji from '../images/myanimoji.png'
import './headercss.css';

class Header extends Component {


  componentDidMount () {
   // var i = 0;
   // // var name = this.state.name.split(" ")[0];
   // var txt = `Hi, I'm Waqqas`;
   // var speed = 100;
   
   // function typeWriter() {
   //   if (i < txt.length) {
   //     document.getElementById("username").innerHTML += txt.charAt(i);
   //     i++;
   //     setTimeout(typeWriter, speed);
   //   }
   // }
   // typeWriter();
  }
   
  render() {

    if(this.props.data){
      var name = this.props.data.name.split(" ")[0];
      var occupation= this.props.data.occupation;
      var description= this.props.data.description;
      var city= this.props.data.address.city;
      var city= this.props.data.address.city;
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
    }

    return (
      <header id="home">

      <nav id="nav-wrap">

         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">About</a></li>
	         <li><a className="smoothscroll" href="#resume">Resume</a></li>
            <li><a className="smoothscroll" href="#portfolio">Works</a></li>
            <li><a className="smoothscroll" href="#contact">Contact</a></li>
            {/*<li><a className="smoothscroll" href="#contact">Contact</a></li>*/}
         </ul>

      </nav>

      <div className="row banner">
         <div className="banner-text">
            <img className="headline-user-image" src={MyAnimoji} height="130em" width="130em"/>
            <h1 style={{maxWidth:'100%', fontSize:'70px', margin:'0 !important', padding:'0 !important', textAlign:'center', marginBlockStart:'0 !important', marginBlockEnd:'0 !important'}} id="username">Hi, I'm Waqqas</h1>
            <h3>I'm a {city} based <span>{occupation}</span>. {description}.</h3>
            <hr />
            <ul className="social">
               {networks}
            </ul>
         </div>
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;
